module.exports = __webpack_public_path__ + "img/check.70fd86be.svg";